export const basePath = "https://api.icontec.org";
export const certIVAPath = "https://api.icontec.org/retencion_iva";
export const certICAPath = "https://api.icontec.org/retencion_ica";
export const certRentaPath = "https://api.icontec.org/retencion_renta";
export const certPDFPath = "https://api.icontec.org/archivos/pdf";
export const userUpPath = "https://api.icontec.org/userupload";
export const newBack = "https://qa.icontec.org:8039/api/";
